import React, {useEffect, useState} from "react";
import useCompanyProfile from "./company-profile.hooks";
import style from "./operational-date.module.css";
import CustomTable from "../../../component/table/CustomTable";
import moment from "moment";
import {useTranslation} from "react-i18next";
import DropdownList from "../../../component/dropdown/DropdownList";
import _ from "lodash";

const OperationalDate = ({setOperationalDateData, ...props}) => {
  const {operationalDate} = useCompanyProfile();
  const {t} = useTranslation();
  const [listData, setListData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [dropdown, setDropdown] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState();
  const [selectedMonthId, setSelectedMonthId] = useState();

  useEffect(() => {
    const fetchData = async () => {
      let bulan = await getMonthId();
      await getDateByMonth(bulan);
    };
    if (_.isEqual(listData, filteredData) && props?.opsDate?.length > 0) {
      currentMonth();
      options();
      setListData(props?.opsDate);
      setFilteredData(props?.opsDate);
      fetchData();
    }
  }, [listData, filteredData]);

  useEffect(() => {
    const fetchData = async () => {
      await getDateByMonth(getMonthId());
    };
    options();
    fetchData();

    // eslint-disable-next-line
  }, [selectedMonth]);

  useEffect(() => {
    const fetchData = async () => {
      await getDateByMonth(getMonthId());
    };
    if (_.isEmpty(listData) || _.isEmpty(props?.opsDate)) {
      setListData(props?.opsDate);
      setFilteredData(props?.opsDate);
      fetchData();
    } else if (!_.isEqual(props?.opsDate, listData)) {
      setListData(props?.opsDate);
      setFilteredData(props?.opsDate);
      fetchData();
    }
    // eslint-disable-next-line
  }, [props?.opsDate]);

  const currentMonth = async () => {
    let date = moment();
    let month = date.format("MMMM YYYY");
    setSelectedMonth(month);
    await getDateByMonth(getMonthId());
  };

  const getMonthId = () => {
    let selectedCode = "";
    dropdown?.forEach((data) => {
      if (data.label === selectedMonth) selectedCode = data.id;
    });
    setSelectedMonthId(selectedCode);
    return selectedCode;
  };

  const options = async () => {
    let date = moment();
    let monthInNumber = date.format("M");
    let year =
      Number(monthInNumber) === 12
        ? Number(date.format("YYYY")) + 1
        : date.format("YYYY");
    var months = moment.months();

    let nextYear = {
      id: "M" + (months.length + 1),
      value: months[0] + " " + (Number(year) + 1),
      label: months[0] + " " + (Number(year) + 1),
    };

    let lastYear = {
      id: "M00",
      value: months[months.length - 1] + " " + (year - 1),
      label: months[months.length - 1] + " " + (year - 1),
    };

    let list = months.map((item, idx) => {
      return {
        id: idx > 10 ? "M" + (idx + 1) : "M0" + (idx + 1),
        value: item + " " + year,
        label: item + " " + year,
      };
    });

    list.push(nextYear);
    list.unshift(lastYear);

    setDropdown(list);
  };

  const onChange = async (e) => {
    setSelectedMonth(e.target.value);
  };

  const getDateByMonth = async (id) => {
    let dateByMonth = [];
    if (id) {
      listData?.forEach((data) => {
        if (
          data.date_start_code === id ||
          checkCode(data.date_start_code, data.date_end_code, id)
        )
          dateByMonth.push(data);
      });
      setFilteredData(dateByMonth);
    }
  };

  const checkCode = (start, end, id) => {
    let code = Number(id.split("-")[0].split("M")[1]);
    if (end) {
      let startMonth = Number(start.split("M")[1]);
      let endMonth = Number(end.split("M")[1]);

      if (startMonth <= code && code <= endMonth) {
        return true;
      }
    }
    return false;
  };

  const ListColumn = [
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("COMPANY_PROFILE:DATE")}
        </span>
      ),
      dataIndex: "date",
      key: "date",
      render: (date) => <span>{date}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("COMPANY_PROFILE:DAYS")}
        </span>
      ),
      dataIndex: "days",
      key: "days",
      render: (days) => <span>{days}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("COMPANY_PROFILE:EVENT_NAME")}
        </span>
      ),
      dataIndex: "event_name",
      key: "event_name",
      render: (event_name) => <span>{event_name}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222]">
          {t("COMPANY_PROFILE:STATUS")}
        </span>
      ),
      dataIndex: "status",
      key: "status",
      render: (status) => status,
    },
  ];

  const getDate = (start, end) => {
    if (start === end) {
      return start;
    } else {
      return start + " - " + end;
    }
  };

  const getDays = (start, end) => {
    const day_start = moment(start).format("dddd");
    const day_end = moment(end).format("dddd");
    if (day_start === day_end) {
      return day_start;
    } else {
      return day_start + " - " + day_end;
    }
  };

  const getEvent = (eventName) => {
    if (eventName.includes("_")) {
      return eventName.split("_")[1];
    }
    return eventName;
  };

  const getStatus = (eventName, status) => {
    if (eventName.includes("_")) {
      return "Public Holidays";
    }
    return status ==="Y" ? "Working Days" : "Holidays";
  };

  const dataSource =
    filteredData.length > 0
      ? filteredData?.map((result) => ({
        date: (
          <span className="font-roboto text-lg text-[#222222]">
              {getDate(result?.date_start, result?.date_end)}
            </span>
        ),
        days: (
          <span className="font-roboto text-lg text-[#222222]">
              {getDays(result?.date_start, result?.date_end)}
            </span>
        ),
        event_name: (
          <span className="font-roboto text-lg text-[#222222]">
              {getEvent(result?.description)}
            </span>
        ),
        status:
          getStatus(result?.description, result?.is_operational_active) ===
          "Working Days" ? (
            <span className="font-roboto text-lg">
                <div
                  style={{background: "#FF00001A", color: "#FF0000"}}
                  className="rounded-[9px] text-roboto text-[16px] w-fit py-[2px] px-[6px]"
                >
                  Working Days
                </div>
              </span>
          ) : getStatus(
            result?.description,
            result?.is_operational_active
          ) === "Public Holidays" ? (
            <span className="font-roboto text-lg">
                <div
                  style={{background: "#eef9ea", color: "#57c22d"}}
                  className="rounded-[9px] text-roboto text-[16px] w-fit py-[2px] px-[6px]"
                >
                  Public Holidays
                </div>
              </span>
          ) : (
            <span className="font-roboto text-lg">
                <div
                  style={{background: "#ecf6ff", color: "#46A3FC"}}
                  className="rounded-[9px] text-roboto text-[16px] w-fit py-[2px] px-[6px]"
                >
                  Holidays
                </div>
              </span>
          ),
      }))
      : null;

  return (
    <div>
      <div className={`mb-[16px] mt-[32px]`}>
        <DropdownList
          id=""
          name=""
          list={dropdown}
          onChange={(e) => onChange(e)}
          value={selectedMonth}
        />
      </div>
      <div className={style.tableContainer}>
        <CustomTable columns={ListColumn} data={dataSource}/>
      </div>
    </div>
  );
};

export default OperationalDate;